import { createContext } from 'react';
import type {
	PositionState,
	PositionInterviewingMode,
} from '@/types/server/enums.types';

// Position status data
export interface PositionStatusData {
	publicId: string;
	title: string;
	state: PositionState;
	interviewingMode: PositionInterviewingMode;
	isAdminAuthenticated: boolean;
}

// Define the shape of our auth context
export interface AuthContextType {
	// Position data
	positionStatus: PositionStatusData | null;
	setPositionStatus: (status: PositionStatusData | null) => void;

	// Admin authentication
	isAdminAuthenticated: boolean;
	positionAdminAuthToken: string | null;
	setPositionAdminAuthToken: (token: string | null) => void;

	// Candidate authentication
	isCandidateAuthenticated: boolean;
	candidateAuthToken: string | null;
	setCandidateAuthToken: (token: string | null) => void;

	// App state
	isInitializing: boolean;
	setIsInitializing: (initializing: boolean) => void;

	// Logout functions
	logoutAdmin: () => void;
	logoutCandidate: () => void;
	clearAllAuth: () => void;
}

// Create the auth context
export const AuthContext = createContext<AuthContextType | undefined>(
	undefined
);
